/**
 * Salesforce Service
 */

import client from './client';

const bulkCreateApprovals = async (params) => {
    let res: any = await client.post("/configuration/approver/bulk-create", params);
    return res;
}
const createApprovals = async (params) => {
    let res: any = await client.post("/configuration/approver/create", params);
    return res;
}
const approverList = async (params) => {
    let res: any = await client.get("/configuration/approver/list", params);
    return res;
}
const getSku = async (params) => {
    let res: any = await client.get("/configuration/sku", params);
    return res;
}
const listing = async (params) => {
    let res: any = await client.get("/configuration/list", params);
    return res;
}
const update = async (params) => {
    let res: any = await client.post("/configuration/update", params);
    return res;
}
const create = async (params) => {
    let res: any = await client.post("/configuration/add", params);
    return res;
}

const getCertificates = async (params) => {

    let res: any = await client.get('/aceExam/getCertificates', params);
    return res
}
const remove = async (params) => {
    let res: any = await client.post("/aceExam/remove", params);
    return res;
}
const activate = async (params) => {
    let res: any = await client.post("/aceExam/activate", params);
    return res;
}
const dashboard = async (params) => {
    let res: any = await client.get("/aceExam/dashboard", params);
    return res;
}
const test = async (params) => {
    let res: any = await client.get("/configuration/invoice", params);
    return res;
}

const getSubmissions = async (params) => {
    let res: any = await client.get("/configuration/customer/submissions", params);
    return res;
}
const createCustomerApproval = async (params) => {
    let res: any = await client.post("/configuration/customer/approval", params);
    return res;
}
const getApprovedBuyUser = async (params) => {
    let res: any = await client.get("/configuration/approved-by", params);
    return res;
}

export default {
    listing, 
    update, 
    getCertificates, 
    create, 
    remove, 
    activate, 
    dashboard,
    approverList,
    createApprovals,
    getSku,
    bulkCreateApprovals,
    test,
    getSubmissions,
    createCustomerApproval,
    getApprovedBuyUser

}